import { render, staticRenderFns } from "./FaceFail.vue?vue&type=template&id=6b279122&scoped=true&"
import script from "./FaceFail.vue?vue&type=script&lang=ts&"
export * from "./FaceFail.vue?vue&type=script&lang=ts&"
import style0 from "./FaceFail.vue?vue&type=style&index=0&id=6b279122&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b279122",
  null
  
)

export default component.exports